/** Roles that have their own dedicated console get sent there as their
 * landing page, instead of the generic rollup grid at "/". Anything not
 * listed here falls through to the default home. Keep this in sync with
 * the route groups in App.tsx. */
const ROLE_HOME: Record<string, string> = {
  state_head: "/sh",
  district_head: "/dh",
};

export function roleHome(role: string | null | undefined): string | null {
  if (!role) return null;
  return ROLE_HOME[role] ?? null;
}
